import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="min-h-screen" data-testid="privacy-policy-page">
      <Header onBookClick={() => {}} />
      
      <main className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="mb-8">
            <Link to="/" className="text-sky-600 hover:underline text-sm">
              ← Back to Home
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8">
            Privacy Policy
          </h1>
          
          <p className="text-slate-500 mb-8">Last Updated: December 2025</p>
          
          <div className="legal-content">
            <p>
              Nova Shelf ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard 
              your information when you visit our website or use our cleaning services.
            </p>

            <h2>Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Fill out our quote request form</li>
              <li>Contact us through our website</li>
              <li>Schedule a cleaning service</li>
              <li>Subscribe to our newsletter</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name and contact information (email, phone number, address)</li>
              <li>Service preferences and requirements</li>
              <li>Scheduling information</li>
              <li>Communication history with our team</li>
            </ul>

            <h3>Automatically Collected Information</h3>
            <p>
              When you visit our website, we may automatically collect certain information 
              about your device, including:
            </p>
            <ul>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>IP address</li>
              <li>Pages viewed and time spent on pages</li>
              <li>Referring website addresses</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and manage our cleaning services</li>
              <li>Respond to your inquiries and fulfill your requests</li>
              <li>Send you service-related communications</li>
              <li>Improve our website and services</li>
              <li>Process payments and send invoices</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>Information Sharing</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. 
              We may share your information only in the following circumstances:
            </p>
            <ul>
              <li>With service providers who assist in our operations</li>
              <li>When required by law or to protect our rights</li>
              <li>With your consent</li>
            </ul>

            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect 
              your personal information against unauthorized access, alteration, disclosure, 
              or destruction. However, no method of transmission over the Internet is 100% 
              secure.
            </p>

            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2>Cookies</h2>
            <p>
              Our website may use cookies and similar tracking technologies to enhance 
              your browsing experience. You can set your browser to refuse cookies, but 
              this may limit some website functionality.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our privacy practices, 
              please contact us at:
            </p>
            <ul>
              <li>Email: support@novashelf.store</li>
              <li>Phone: +1-888-453-2345</li>
              <li>Address: 1587 Magnolia Court, Houston, TX 77002</li>
            </ul>

            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of 
              any changes by posting the new Privacy Policy on this page and updating the 
              "Last Updated" date.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
